<style lang="scss" scoped>
  .content {
    max-width: 1200px;
  }
  .c-card {
    max-width: 270px;
    margin-right: 100px;
  }
  .box {
    width: 100px;
    height: 100px;
    background: red;
  }
  textarea {
    height: 200px;
  }
  .support {
    max-width: 500px;
  }
  .column {
    padding-top: 0px;
  }
  .file {
    text-transform: capitalize;
  }
  .description {
    font-size: 15px;
    padding-top: 3px;
    padding-bottom: 20px;
  }
</style>

<template>
  <c-layout>
    <template #title>Support</template>
    <template #content>

      <!-- contact us -->
      <div class="is-size-6 pb-5">
        <div class="heading mb-5">Contact Us</div>
        <p class="pb-3">
          Fend Incorporated<br>
          4600 Fairfax Drive, Suite 410, Arlington VA<br>
          support@fend.tech  /  Tel. 571-970-1382
        </p>
        <p class="pb-2">
          Send us an email at <a href="mailto: support@fend.tech">support@fend.tech</a> or
          reach out to us using the contact us widget on the bottom right of this page.
        </p>
      </div>

      <!-- downloads -->
      <div>
        <div class="heading">Downloads</div>
        <div class="download" v-for="(download, i) in downloads" :key="download.file + i">
          <a :href="download.link" target="_blank">{{download.name}} <c-icon icon="fas-download"/></a>
          <p class="description">{{download.description}}</p>
        </div>
      </div>

    </template>
  </c-layout>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'support',
  computed: {
    downloads: get('downloads')
  },
  mounted() {
    document.getElementById('jsd-widget').style.visibility = 'visible';
  },
  destroyed() {
    document.getElementById('jsd-widget').style.visibility = 'hidden';
  }
};
</script>
